import React from 'react'
import styled from 'styled-components'
import { Heading, Text, BaseLayout } from '@pancakeswap-libs/uikit'
import useI18n from 'hooks/useI18n'
import Page from 'components/layout/Page'
import DNDHeader from 'components/DNDHeader'
import {HeaderAndUnder,UnderHeaderText,HeaderBottom} from 'components/HeaderAndUnder';
import FarmStakingCard from './components/FarmStakingCard'
// import LotteryCard from './components/LotteryCard'
import CakeStats from './components/CakeStats'
import TotalValueLockedCard from './components/TotalValueLockedCard'
import TwitterCard from './components/TwitterCard'



const MobileLogo = styled.img`
  ${({ theme }) => theme.mediaQueries.lg} {
	display:none;
  }
`


const Cards = styled(BaseLayout)`
  align-items: stretch;
  justify-content: stretch;
  margin-bottom: 48px;

  & > div {
    grid-column: span 6;
    width: 100%;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    & > div {
      grid-column: span 8;
    }
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    & > div {
      grid-column: span 6;
    }
  }
`

//<p className="text" dangerouslySetInnerHTML={{__html: TranslateString(3000, 'qwe')}} />

const Home: React.FC = () => {
  const TranslateString = useI18n()

  return (
	<HeaderAndUnder
	headerChildren={
		<HeaderBottom>
		<h1>Welcome to DungeonSwap</h1>
<p>Play-to-earn <a href='/AncientDungeon'>Ancient Dungeon</a> V2 is now live!</p>
		</HeaderBottom>
	}
	headerBG={`${process.env.REACT_APP_MEDIA_ROOT}header/1_Title.jpg`}
	underBG={`${process.env.REACT_APP_MEDIA_ROOT}bg/background_dark.jpg`}
	>

	
	<MobileLogo src="/images/dungeon/logo.png" alt="asd"/>

	
	<UnderHeaderText>
		<p><a href='/dungeon'>Click here</a> to enter the Risk-to-earn Classic Dungeon.</p>
		<p><a href='/relicStore'>Click here</a> to purchase Relics (Play-to-earn NFT).</p>
	</UnderHeaderText>


      <div>
        <Cards>
          <FarmStakingCard />
          <TwitterCard />
          <CakeStats />
          <TotalValueLockedCard />
        </Cards>
      </div>
    </HeaderAndUnder>
  )
}

export default Home

/*
      <Hero>
        <Heading as="h1" size="xl" mb="24px" color="secondary">
          {TranslateString(576, 'DND Finance')}
        </Heading>
        <Text>{TranslateString(578, 'Top 3 best DEFI app on Binance Smart Chain.')}</Text>
      </Hero>
*/
